module.exports = __webpack_public_path__ + "media/images/front/img_movie_feature01-f6fdd3b2916f242be6da0513e7206770.jpg";